export default {"src":"/_next/static/media/lawyerTalk_24.cc4fcd12.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};